import * as yup from 'yup'

export const internationalPersonSchema = yup.object({
  name: yup
    .string()
    .required('REQUIRED_FIELD')
    .matches(
      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
      'INVALID_NAME'
    ),
  email: yup.string().email('INVALID_EMAIL').required('REQUIRED_FIELD'),
  phone: yup.string().required('REQUIRED_FIELD'),
  linkedin: yup.string().notRequired().nullable(),
  city: yup.string().required('REQUIRED_FIELD'),
  state: yup.string().required('REQUIRED_FIELD'),
  country: yup.string().required('REQUIRED_FIELD'),
})
